import { processMouseOverAndMouseMoveDiagPath } from "./processMouseOverAndMouseMoveDiagPath";

export function addMouseEventHandling(path, mapsData, specificCarHistoryData, setHoverStateHistory, polyLinesData, setPolyLineState, carHistoryList) {
    mapsData.event.addListener(path, "mouseover", function (event) {
      processMouseOverAndMouseMoveDiagPath(event, path.car, specificCarHistoryData, polyLinesData, setHoverStateHistory);
    });
  
    mapsData.event.addListener(path, "mousemove", function (event) {
      processMouseOverAndMouseMoveDiagPath(event, path.car, specificCarHistoryData, polyLinesData, setHoverStateHistory);
    });
  
    mapsData.event.addListener(path, "mouseout", function (event) {
      let NumOfSelectedCarsForHistory = specificCarHistoryData
        ? Object.keys(specificCarHistoryData).length
        : 0;
      setHoverStateHistory({});
      polyLinesData.forEach((hop) => {
        if (hop.car === path.car) {
          hop.isHoveredOver = false;
          hop?.setOptions({
            strokeColor: hop.strokeColorUsed,
            strokeWeight: NumOfSelectedCarsForHistory > 1 ? 3 : 5,
            strokeOpacity: path.strokeOpacityUsed,
            zIndex: path.zIndexUsed,
          });
        }
      });
      setPolyLineState(polyLinesData);
    });
  
    mapsData.event.addListener(path, "click", function (event) {
      polyLinesData.forEach((it) => {
        if (it.car !== path.car) it.setMap(null);
      });
      carHistoryList.set([path.car]);
      polyLinesData = polyLinesData.filter((it) => it.car === path.car);
      polyLinesData.forEach((hop) => {
        hop?.setOptions({
          strokeColor: path.strokeColorUsed,
          strokeWeight: 4,
          strokeOpacity: path.strokeOpacityUsed,
          zIndex: path.zIndexUsed,
        });
      });
      setPolyLineState(polyLinesData);
    });
  }